import React, { Dispatch, useContext } from "react";
import { Button } from '../../../../../components';
import { OfferContext } from '../../utils/OfferProvider';
import DefaultModal from '../../../../../components/modals/DefaultModal';

interface ChangeProductModalProps {
    showModal: boolean,
    setShowModal: Dispatch<boolean>,
    /** Applies the product the operator picked (selection by catalog _id). */
    onConfirm: () => void;
    onCancel?: () => void;
    setSelectedPackageNames: Dispatch<string[]>;
}

const ChangeProductModal: React.FC<ChangeProductModalProps> = ({
    showModal,
    setShowModal,
    onConfirm,
    onCancel,
    setSelectedPackageNames,
}) => {

    const {
        setOfferBookCategories,
        setOfferBookPackages,
        setOfferBookPackageNames,
        setBooksOptions,
        setDefaultPackages,
        availableBookPackages,
        setAllowedBookEmphasis,
    } = useContext(OfferContext);

    const handleChangeProduct = () => {
        setAllowedBookEmphasis([]);
        setBooksOptions(availableBookPackages);
        setOfferBookCategories([]);
        setOfferBookPackages([]);
        setOfferBookPackageNames([]);
        setSelectedPackageNames([]);
        setDefaultPackages([]);
        setBooksOptions([]);
        onConfirm();

        setShowModal(false);
    };

    return (
        <DefaultModal
            showModal={showModal}
            setShowModal={setShowModal}
            size='lg'
            title="Change Product"
            dismissible={false}
        >
            <div className="flex flex-col gap-4 text-sm font-medium">
                <span>You’ve made changes to the packages.</span>
                <span>
                    Are you sure you want to select a different product? This will remove any packages you’ve added.
                </span>
            </div>

            <div className="flex gap-2 justify-end mt-[34px]">
                <Button
                    variant="OUTLINED"
                    onClick={() => {
                        onCancel?.();
                        setShowModal(false);
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="DANGER"
                    onClick={handleChangeProduct}
                >
                    Change product
                </Button>
            </div>

        </DefaultModal>)

}

export default ChangeProductModal;